// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3r-r4","right":"styles_right__9kR4m"};